<template>
  <v-container
    fluid
    class="pa-0">
    <v-row
      v-for="(bookingDetails, ind) in allBooking"
      :key="ind"
    >
      <v-col cols="12">
        <v-card>
          <v-card-title class="text-overline pl-4 pr-4 pt-2 pb-2">
            {{ bookingDetails.title }}
          </v-card-title>
          <v-divider/>

          <v-card-text class="text--primary">
            <div v-if="bookingDetails.description!=''">{{ bookingDetails.description }} </div>

            <div><span class="font-weight-medium">Child: </span>{{ bookingDetails.pupilName }} </div>

            <div><span class="font-weight-medium">Date: </span>{{ bookingDetails.interviewDate }} at {{ bookingDetails.time }}</div>
            <div><span class="font-weight-medium">Location: </span>{{ bookingDetails.location }} </div>
            <div><span class="font-weight-medium">Teacher: </span>{{ bookingDetails.teacherName }} </div>
            <div><span
              class="font-weight-medium"
              v-if="bookingDetails.caregiverBoxComment!='' && bookingDetails.parentnotes!='' ">{{ bookingDetails.caregiverBoxComment }}: </span>{{ bookingDetails.parentnotes }} </div>
            <div v-if="bookingDetails.feedback!=''"><span class="font-weight-medium">Teacher Feedback: </span>{{ bookingDetails.feedback }} </div>

          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-chip
              :color="
              bookingDetails.color"
              class="white--text">{{ bookingDetails.status }}</v-chip>
            <v-spacer/>

            <v-btn
              icon
              @click.stop="goToPrint(bookingDetails.printUrl.link)">
              <v-icon>print</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-col>

    </v-row>

  </v-container>

</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    allBooking: {
      type: Array,
      default: () => { return {} }
    }
  },

  components: {

  },

  data: function () {
    return {
      tealColor: '#00B0B9',
      alertMsg: '',
      alertColor: ''

    }
  },

  computed: {
    ...mapState(['Dbasename', 'schoolId', 'status', 'teacherId', 'teacherName', 'loadingDialog', 'withPinSetup'])

  },

  methods: {
    goToPrint: function (link) {
      window.open(link, '_blank')
    }
  }
}
</script>
